module.exports = __webpack_public_path__ + "static/media/communal-back.ca8b3bf1.png";